import { Card } from "@/components/CardGrid/types";
import getWebviewUrl from "@/utils/webview/getWebviewUrl";

const addWebviewLinkToCards = (cards: Card[]): Card[] =>
  cards.map((card) => {
    const webviewUrl = getWebviewUrl(card.href);
    const href = webviewUrl.includes("webview")
      ? webviewUrl
      : `/webview/v2${card.href.startsWith("/") ? card.href : `/${card.href}`}`;
    return { ...card, href };
  });

export default addWebviewLinkToCards;
